export const dateConstant = {
    UPDATE_MESSAGE_DATE_PERSIST: 'UPDATE_MESSAGE_DATE_PERSIST',
};
